import { getLoginUinfo } from '@m2h/common/utils';
import { getLxAttributionContext } from './attributionContext';

const LXAnalytics = (top as any).LXAnalytics;
const tracker = LXAnalytics('getTracker');
let pageCase: Function | null = null;

const mergeCommonParams = (iparams?: object) => {
  const { uid = 0 } = getLoginUinfo() || {};
  // 与 Tracker 环境字段使用同一份归因快照，保证灵犀两个字段位置的数据一致。
  const attributionParams = getLxAttributionContext();

  const custom = {
    uid,
    ...attributionParams,
  };

  const params = Object.entries(iparams || {}).reduce((p, [key, val]) => {
    return {
      ...p,
      [key]: val === undefined ? '' : val,
    };
  }, {});

  return {
    ...params,
    custom: {
      ...custom,
      // 业务事件显式传入同名字段时优先，避免改变已有埋点语义。
      ...params,
    },
  };
};

export function lxPV(cid: string, params) {
  const valLab = mergeCommonParams(params);
  // console.log('lxPV|valLab', valLab)
  // @ts-ignore
  // window.LXAnalytics('pageView', valLab, null, cid);
  pageCase = tracker('pageView', valLab, null, cid);
}

// 灵犀上报 moduleClick
export function lxMC(bid: string, cid: any, params) {
  const valLab = mergeCommonParams(params);
  // console.log('lxMC|valLab', valLab)
  // @ts-ignore
  window.LXAnalytics('moduleClick', bid, valLab, { cid });
}

export function lxMV(bid: string, cid: any, params) {
  // console.log('lxMV', bid, params);
  const valLab = mergeCommonParams(params);
  // @ts-ignore
  window.LXAnalytics('moduleView', bid, valLab, { cid });
}

export function lxSetTag(category: string, params: any) {
  // console.log('lxSetTag', category, params);
  Object.entries(params || {}).map(([tagKey, tagValue]) => {
    // @ts-ignore
    window.LXAnalytics('tag', category, tagKey, tagValue);
  });
}

export function lxOrder(cid: string, bid: string, data?: Record<string, any>, category?: string) {
  // 触发BO事件的埋点上报（用户点击下单发送此事件）
  const orderData = data || {};
  const valLab = mergeCommonParams(orderData);
  if (!pageCase) {
    pageCase = tracker('pageView', valLab, null, cid);
  }
  // @ts-ignore
  pageCase('order', bid, orderData.order_id, valLab);
}
